export type HeadphoneStatus = 'detected' | 'not_detected' | 'unknown';

export interface HeadphoneCheckResult {
  status: HeadphoneStatus;
  label?: string;
}

const HEADPHONE_KEYWORDS = /headphone|headset|earphone|earbud|airpods|耳機|耳机|이어폰|헤드폰|헤드셋|ヘッドフォン|ヘッドセット|イヤホン/i;

export async function detectHeadphone(): Promise<HeadphoneCheckResult> {
  if (!navigator.mediaDevices?.enumerateDevices) {
    return { status: 'unknown' };
  }
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const outputs = devices.filter(d => d.kind === 'audiooutput');
    if (outputs.length === 0) return { status: 'unknown' };
    const hasLabels = outputs.some(d => d.label);
    if (!hasLabels) return { status: 'unknown' };
    const headphone = outputs.find(d => HEADPHONE_KEYWORDS.test(d.label));
    if (headphone) return { status: 'detected', label: headphone.label };
    return { status: 'not_detected' };
  } catch {
    return { status: 'unknown' };
  }
}
